import React from "react";
import { Divider, Flex, Button, Modal, Spin } from "antd";
import queryString from 'query-string';
import GlobalSpinLoading from "../../components/global-loading";
import { detectScreen } from '../../utils/device';

const screen = detectScreen();

const PageTitle = {
    wxopen_service: '微信服务号信息',
    wxopen_mini: '微信小程序信息',
}
export default () => {
    const [detail, setDetail] = React.useState({});
    const [loading, setLoading] = React.useState(false);
    const [path, params] = window.location.href.split('?')
    const paramsObj = queryString.parse(params || '') || {};
    React.useEffect(() => {
        getDetail().then(res => {
            console.log(res);
            setDetail(res);
        });
    }, []);
    const getDetail = async () => {
        const response = await fetch(`/api/channel/oauth/detail?type=${paramsObj.type}`);
        const result = await response.json();

        if(result?.success) {
            return result.data;
        }
        return {};
    }
    async function initTemplate() {
        setLoading(true);
        const response = await fetch(`/api/wxservice/initTemplate`);
        const result = await response.json();
        const {
            success, data = []
        } = result;
        let title = '';
        const successTextList = [];
        const errorTextList = [];
        let successType = '';
        let allSuccess = true;
        let hasSuccess = false;

        data.forEach(item => {
            allSuccess = allSuccess && item.success;
            hasSuccess = hasSuccess || item.success;
            const text = `${item?.template?.type} ${item.success ? '成功' : ('失败' + item?.content?.errmsg)}`;
            if (!item.success) {
                errorTextList.push(text);
            } else {
                successTextList.push(text);
            }
        });

        if (allSuccess) {
            successType = 'all';
            title = '全部初始化成功';
        } else {
            if (hasSuccess) {
                successType = 'part'
                title = '部分失败';
            } else {
                successType = 'fail'
                title = '全部失败';
            }
        }
        setLoading(false);
        Modal.info({
            title,
            content: (
            <div>
                <div style={{color: 'red'}}>
                {
                    errorTextList.map(item => {
                        <p>{item}</p>
                    })
                }
                </div>
                <div style={{marginTop: 16}}>
                {
                    successTextList.map(item => {
                        <p>{item}</p>
                    })
                }
                </div>
                
            </div>
            ),
            onOk() {},
        });
    }

    return (
        <div>
            <h2>{PageTitle[paramsObj.type]}</h2>
            <Divider />
            <Flex gap={10} wrap="wrap" style={{fontSize: '16px'}}>

                <div style={{width: '100%'}}>
                    <img src={detail?.head_image_info?.head_image_url} width={30} style={{ verticalAlign: 'middle' }} />
                    {detail.nickname}
                </div>
                <div>appId：{detail.appid}</div>
                <div>主体名称：{detail.principal_name}</div>
            </Flex>
            <div>
                <span>二维码</span>:
                <img src={`https://img.yxdj.tech/${detail.erCode}`} style={{ verticalAlign: 'middle', width: 200 }} />
            </div>
            <Divider />
            <Button href={`/wxopen/oauth?type=${paramsObj.type}&pageType=${screen}`}>重新授权</Button>
            {
                paramsObj.type === 'wxopen_service' ? (
                    <Button onClick={initTemplate}  style={{marginLeft: 24}}>初始化消息模版</Button>
                ) : null
            }
            <GlobalSpinLoading visible={loading} />
        </div>
    )
}